"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unauthorizedErrorCode = exports.authContract = void 0;
const json_rpc_1 = require("@hediet/json-rpc");
exports.authContract = (0, json_rpc_1.contract)({
    name: "auth",
    client: {},
    server: {
        /* def */ login: (0, json_rpc_1.requestType)({
            params: json_rpc_1.semanticJson.sObject({
                usernameOrEmail: json_rpc_1.semanticJson.sString(),
                password: json_rpc_1.semanticJson.sString(),
            }),
            result: json_rpc_1.semanticJson.sObject({
                authToken: json_rpc_1.semanticJson.sString(),
            }),
        }),
        /* def */ changePassword: (0, json_rpc_1.requestType)({
            params: json_rpc_1.semanticJson.sObject({
                oldPassword: json_rpc_1.semanticJson.sString(),
                newPassword: json_rpc_1.semanticJson.sString(),
            }),
        }),
        /* def */ authenticate: (0, json_rpc_1.requestType)({
            params: json_rpc_1.semanticJson.sObject({
                authToken: json_rpc_1.semanticJson.sString(),
            }),
        }),
        /* def */ destroySession: (0, json_rpc_1.requestType)({}),
        /* def */ getCurrentUserInformation: (0, json_rpc_1.requestType)({
            result: json_rpc_1.semanticJson.sObject({
                email: json_rpc_1.semanticJson.sString(),
                username: json_rpc_1.semanticJson.sString(),
                isSiteAdmin: json_rpc_1.semanticJson.sBoolean(),
            }),
        }),
    },
});
exports.unauthorizedErrorCode = json_rpc_1.ErrorCode.applicationError(401);
//# sourceMappingURL=loginContract.js.map